export const EMPLOYEE_RESPONSE_FIELD = 'employeeResponse';
export const COMMENTS_FIELD = 'comments';
export enum EmployeeStatus {
  Done = 'DONE',
}
